import { importExport } from './import-export.i18n';

export const en = {
  importExport,
};
